import { Resolution } from 'react-to-pdf';

export const MM_TO_PX = 3.77952755906;
export const RESOLUTION = Resolution.NORMAL;
export const HEADER_MARGIN = 5;
export const FOOTER_MARGIN = 10;
